export default __webpack_public_path__ + "static/media/Clan Bound Straps of the Clans.711f62b3.jpg";